module.exports = __webpack_public_path__ + "img/crypto-doge.bfe942ea.svg";